import { FormField, FormItem, FormMessage } from '@/components/ui/form'
import { useFormContext } from 'react-hook-form'

const GenericFormError = ({ customError }: { customError?: string }) => {
  const form = useFormContext()

  return (
    <FormField
      control={form.control}
      name='genericError'
      render={() => (
        <FormItem className='mt-4'>
          <FormMessage>{customError}</FormMessage>
        </FormItem>
      )}
    />
  )
}

export default GenericFormError
